module.exports = {"common":"中午呢"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/zh.json
// module id = ODm5
// module chunks = 1